/**
 * TanStack Query hooks for `iterable-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	iterableIntegrationQueryKeys,
	type CreateIterableIntegrationBody,
	type ListIterableIntegrationResponse,
	type IterableIntegrationRow,
} from "./api";

export function useIterableIntegrationList(): UseQueryResult<ListIterableIntegrationResponse, Error> {
	return useQuery({
		queryKey: iterableIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIterableIntegrationCreate(): UseMutationResult<IterableIntegrationRow, Error, CreateIterableIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: iterableIntegrationQueryKeys.all });
		},
	});
}

export function useIterableIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: iterableIntegrationQueryKeys.all });
		},
	});
}
